export default __webpack_public_path__ + "static/media/apex.efd8fa7f.jpg";